export const transferConfirmationValues = [
  'Source Account:',
  'Transaction Type:',
  'Transaction ID:',
  'Beneficiary Account No:',
  'Beneficiary Name:',
  'Narration:',
  'Total Amount:',
];

export const mobileMoneyConfirmationValues = [
  'Source Account:',
  'Transaction Type:',
  'Transaction ID:',
  'Beneficiary Name:',
  'Beneficiary Wallet Number:',
  'Network:',
  'Narration:',
  'Total Amount:',
];

export const prepaidCardConfirmationValues = [
  'Source Account:',
  'Transaction Type:',
  'Transaction ID:',
  'Beneficiary Name:',
  'Last Card Digit:',
  'Narration:',
  'Total Amount:',
];

export const bulkTransferConfirmationValues = [
  'Source Account:',
  'Transaction Type:',
  'Transaction ID:',
  'Total Amount:',
];

export const FXTransferConfirmationValues = [
  'Source Account:',
  'Transaction Type:',
  'Generic Type:',
  'Transaction ID:',
  'Swift Code:',
  'Routing No:',
  'Currency Code:',
  'Beneficiary Country:',
  'Narration:',
  'Total Amount:',
];

export const defaultConfirmationValues = [
  'Source Account:',
  'Transaction Type:',
  'Transaction ID:',
  'Narration:',
  'Total Amount:',
];
